module.exports = __webpack_public_path__ + "static/img/UAlogo.70f7501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UAlogo.png
// module id = qnEC
// module chunks = 0